import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { UserInfo } from '@/api/auth'

export const useUserStore = defineStore('user', () => {
  // 用户信息
  const userInfo = ref<UserInfo | null>(null)
  const token = ref<string>('')
  
  // 是否已登录
  const isLoggedIn = ref<boolean>(false)
  
  // 设置用户信息
  const setUserInfo = (info: UserInfo | null) => {
    userInfo.value = info
    isLoggedIn.value = true
    if (info) {
      localStorage.setItem('userInfo', JSON.stringify(info))
    }
  }
  
  // 设置token
  const setToken = (newToken: string) => {
    token.value = newToken
    localStorage.setItem('token', newToken)
  }
  
  // 清除用户信息
  const clearUser = () => {
    userInfo.value = null
    token.value = ''
    isLoggedIn.value = false
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }
  
  // 从本地存储初始化
  const initFromStorage = () => {
    const storedToken = localStorage.getItem('token')
    const storedUserInfo = localStorage.getItem('userInfo')
    
    if (storedToken) {
      token.value = storedToken
    }
    
    if (storedUserInfo) {
      try {
        const parsedUserInfo = JSON.parse(storedUserInfo)
        userInfo.value = parsedUserInfo
        isLoggedIn.value = true
      } catch (error) {
        console.error('Failed to parse stored user info:', error)
        clearUser()
      }
    }
  }
  
  // 权限检查
  const hasUploadPermission = () => {
    const upload = userInfo.value?.is_upload
    return Boolean(userInfo.value?.is_admin) || upload === 1 || upload === true
  }
  
  const hasLookPermission = () => {
    const look = userInfo.value?.is_look
    return Boolean(userInfo.value?.is_admin) || look === 1 || look === true
  }
  
  const isAdmin = () => {
    return Boolean(userInfo.value?.is_admin)
  }
  
  const hasAiAdvancedPermission = () => {
    const aiAdvanced = userInfo.value?.ai_advanced_permission
    return Boolean(userInfo.value?.is_admin) || aiAdvanced === 1 || aiAdvanced === true
  }
  
  return {
    userInfo,
    token,
    isLoggedIn,
    setUserInfo,
    setToken,
    clearUser,
    initFromStorage,
    hasUploadPermission,
    hasLookPermission,
    isAdmin,
    hasAiAdvancedPermission
  }
})